import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewNationals = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/national/add`, data);
  return res.data;
};
export const updateNationals = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=national&id=${id}`,
    data
  );
  return res.data;
};
export const getAllNationals = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/national?start_date=${data.start_date}&end_date=${data.end_date}/`
  );
  return res.data;
};
export const getNationalsById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/national/${id}`);
  return res.data;
};

export const getAllNationalsSuper_Distributor = async (data) => {
  const { id, type } = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/filter/distributorNational_data?user_id=${id}&user_type=${type}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getAllNationalsDistributor = async (data) => {
  const { id, type } = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/filter/disNational_data?user_id=${id}&user_type=${type}&start_date=${data.start_date}&end_date=${data.end_date}/`
  );
  return res.data;
};
export const getAllNationalsFinancer = async (data) => {
  const { id, type } = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/filter/financerdata?user_id=${id}&user_type=${type}&start_date=${data.start_date}&end_date=${data.end_date}/`
  );
  return res.data;
};
export const getAllNationalsRetailer = async (data) => {
  const { id, type } = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/filter/retailerdata?user_id=${id}&user_type=${type}&start_date=${data.start_date}&end_date=${data.end_date}/`
  );
  return res.data;
};
